import { render, staticRenderFns } from "./activity-materials.vue?vue&type=template&id=31b5291c&"
import script from "./activity-materials.vue?vue&type=script&lang=js&"
export * from "./activity-materials.vue?vue&type=script&lang=js&"
import style0 from "./activity-materials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports